/**
 * Mockup JS pro modál. Řeší správné přidání class podle scrollbarů (aby na Windows při zavírání nedocházelo
 * k poskakování obsahu) a zavírání modálu. V reálné aplikaci by modál měl řešit také otevírání (v šablonách pouze
 * nasimulováno novou šablonou s předem otevřeným modálem) ovládání klávesnicí (např. zavření přes Esc), přesunování
 * focusu dovnitř, atd. Otevření modálu buď načte obsah AJAXem nebo může využívat předgenerovaných formulářů pouze
 * skrytých v rámci Vue.js např. přes v-if.
 */

;(function () {
	const modalElement = document.querySelector('.pd-modal')
	const modalWindowElement = modalElement?.querySelector('.pd-modal__window')

	if (!modalElement || !modalWindowElement) {
		return false
	}

	// Nastavení class spojených se scrollbary; toto by mělo být dynamicky při změně obsahu (ať už modálu nebo dokumentu)
	const scrollElement = document.scrollingElement || document.documentElement
	const isDocumentScrolling = scrollElement.scrollHeight > scrollElement.clientHeight
	const isModalScrolling = modalWindowElement.scrollHeight > document.documentElement.clientHeight

	if (isDocumentScrolling) {
		document.documentElement.classList.add('pd-modal-open--scrollbar-offset')
	} else {
		modalWindowElement?.classList.toggle('pd-modal__window--scrollbar-offset', isModalScrolling)
	}
	document.documentElement.classList.add('pd-modal-open')

	// Zavírání modálu
	const closingDuration = parseInt(
		getComputedStyle(document.documentElement).getPropertyValue('--pd-modal-closing-duration') || '0'
	)
	const closeModal = (event: Event) => {
		event.preventDefault()

		modalElement?.classList.add('pd-modal--closing')
		setTimeout(() => {
			document.documentElement.classList.remove('pd-modal-open', 'pd-modal-open--scrollbar-offset')
			modalElement?.remove()
		}, closingDuration)
	}

	modalWindowElement.addEventListener('click', (event) => {
		if (
			event.target === modalWindowElement ||
			(event.target && (event.target as HTMLElement).closest('.pd-modal__close'))
		) {
			closeModal(event)
		}
	})
})()
